import React, {Component, Fragment} from "react";
import {
  Col,
  FormGroup,
  FormText,
  Input,
  InputGroup,
  Label,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane
} from "reactstrap";
import {
  formsCheckboxUpdater,
  formsMultiUpdater,
  formsUpdater,
  getFormFieldValue,
  zPad
} from "../Applications/shared/shared";
import classnames from 'classnames';
import Select from "react-select";
import "react-select/dist/react-select.min.css"
import {hourMarks, minMarks} from "../../constants/MiscData";
import {EventClient} from "../../util/eventClient";
import {getData, postData} from "../../api/doLogin";
import {isNumber} from "../../util/numberhelpers";
import {addHours, forceUTCTimeZone, formatDateLocal, makeDate} from "../../util/datehelpers";
import moment from "moment";
import NotesTab from "../Leads/views/NotesTab";
import FilesTab from "./FilesTab";
import TasksTab from "./TasksTab";
import {getGlobalState} from "../../constants/GlobalStore";
import {hasPermission} from "../../api/permissionHelper";
import {RequiredPermissions} from "../../api/permissions";

export default class EventEntryEditor extends Component {

  constructor(props) {
    super(props);
    this.state = {
      eventTypes: [],
      eventLinks: [],
      users: [],
      tasks: [],
      files: [],
      notes: [],
      dataLoaded: false,
      formData: {}, // Left off here. Make edit be ID and retrieve Entry data with appt Constants.
      activeTab: "event"
    };
    if (props['addSelection'] && Object.keys(props['addSelection']).length > 1) {
      const tempEvent = {};
      tempEvent['startdate'] = formatDateLocal(props.addSelection['start']);
      tempEvent['starthour'] = props.addSelection['start'].getHours();
      tempEvent['startmin'] = props.addSelection['start'].getMinutes();

      const endAt = props.addSelection['end'] || addHours(props.addSelection['start'], 1);
      tempEvent['enddate'] = formatDateLocal(endAt);
      tempEvent['endhour'] = endAt.getHours();
      tempEvent['endmin'] = endAt.getMinutes();

      if (tempEvent['starthour'] === 0 && tempEvent['startmin'] === 0 && tempEvent['endhour'] === 0 && tempEvent['endmin'] === 0) {
        tempEvent['allDay'] = true;
      }
      this.state.formData = tempEvent;
    }

  }

  componentWillMount() {
    EventClient.on(this.props.saveEvent, () => this.saveExternal(), this.props.eventName);
    this.getDBConstants();

  }

  componentWillUnmount() {
    EventClient.off(this.props.saveEvent, () => this.saveExternal(), this.props.eventName);
  }

  saveExternal() {
    // console.log(this.state.formData);
    this.save((resp) => {
      if (this.props.onSave) {
        this.props.onSave(resp);
      }
    })
  }

  saveInternval() {

  }

  getDBConstants() {
    const self = this;
    getData("events/get/" + this.props.edit || 0, {}, this.props.token)
      .then((data) => {
        // console.log(data.data)
        if (data.status === "Success") {
          const currentUserId = getGlobalState("loginID") || 0;
          let responseStateData = {
            eventTypes: data.data.eventTypes,
            eventLinks: data.data.eventLinks,
            dataLoaded: true,
            notes: data.data.notes,
            files: data.data.files,
            tasks: data.data.tasks,
            users: data.data.users.map((user) => {
              return {
                value: user.id,
                label: `${user.lname}, ${user.fname}`,
                visible: user.visible,
                perms: user.perms,
                assigned: this.props.edit !== "add" ? user.assigned : Number(user.id) === Number(currentUserId) ? 1 : 0
              }
            }).sort((userA, userB) => userA.label > userB.label ? 1 : -1)
          };
          if (isNumber(self.props.edit)) {
            if (data.data.event) {
              const tempEvent = data.data.event;
              const start = forceUTCTimeZone(makeDate(tempEvent.starttime));
              const end = forceUTCTimeZone(makeDate(tempEvent.endtime));
              const socstart = forceUTCTimeZone(makeDate(tempEvent.soc_start));
              const socend = forceUTCTimeZone(makeDate(tempEvent.soc_end));
              // console.log(tempEvent.startdate, start)
              // console.log(tempEvent.endtime, end)
              tempEvent['startdate'] = formatDateLocal(start);
              tempEvent['starthour'] = start.getHours();
              tempEvent['startmin'] = start.getMinutes();
              tempEvent['enddate'] = formatDateLocal(end);
              tempEvent['endhour'] = end.getHours();
              tempEvent['endmin'] = end.getMinutes();
              tempEvent['allDay'] = Number(tempEvent.allDay) === 1;
              tempEvent['socstart'] = formatDateLocal(socstart);
              tempEvent['socend'] = formatDateLocal(socend);
              responseStateData['formData'] = tempEvent;
            } else {
              if (self.props.onClose) {
                setTimeout(() => self.props.onClose(), 200);
                return;
              }
            }
          }
          self.setState(responseStateData);
        }
      }).catch((error) => {
      console.log(error);
    });
  }

  save(cb) {
    const self = this;
    const formData = {...this.state.formData}
    if (!isNumber(self.props.edit)) {
      delete formData.id;
    }
    const payload = {
      formData: {
        aar_notes: "",
        code: "",
        details: "",
        location: "",
        notes: "",
        redirectURL: "",
        source: "",
        subject: "",
        eventtype: 0,
        ...formData,
        assignedUsers: this.state.users.filter((user) => user.assigned === 1).map((user) => Number(user.value))
      }, action: isNumber(self.props.edit) ? "update" : "add"
    };
    payload.formData.starthour = Number(payload.formData.starthour || 0);
    payload.formData.startmin = Number(payload.formData.startmin || 0);
    payload.formData.endhour = Number(payload.formData.endhour || 0);
    payload.formData.endmin = Number(payload.formData.endmin || 0);
    payload.formData.eventtype = Number(payload.formData.eventtype || 0);
    payload.formData.allDay = payload.formData.allDay === 1 ? 1 : payload.formData.allDay === true ? 1 : 0;
    payload.formData.soc_media = payload.formData.soc_media === 1 ? 1 : payload.formData.soc_media === true ? 1 : 0;

    postData("events/save", payload, this.props.token)
      .then((data) => {
        // console.log(data);
        if (data.status === "Success") {
          if (!isNumber(self.props.edit)) {
            cb({...this.state.formData, id: data.data.id});
          } else {
            cb({...this.state.formData});
          }
        }
      })
      .catch(error => {
        console.error(error);
      });
  }

  toggleTab(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab
      });
    }
  }

  dateValidator(startUpdated) {
    const self = this;
    const dateBuilder = function (when) {
      let s = "".concat(self.state.formData[when + 'date'], " ", zPad(String(self.state.formData[when + 'hour'] || 0), 2), ":", zPad(String(self.state.formData[when + 'min'] || 0), 2), ":00");
      return s;
    }
    const momentDate = function (dateString) {
      return moment(dateString, "YYYY-MM-DD HH:mm:ss", true);
    }
    const startDate = momentDate(dateBuilder("start"));
    const endDate = momentDate(dateBuilder("end"));
    if (startUpdated === 'start') {
      if (startDate.isValid() && endDate.isValid()) {
        if (startDate.isAfter(endDate)) {
          formsMultiUpdater({
            enddate: this.state.formData.startdate,
            endhour: this.state.formData.starthour || 0,
            endmin: this.state.formData.startmin || 0
          }, this.state.formData, this);
        }
      } else if (startDate.isValid() && !endDate.isValid()) {
        formsMultiUpdater({
          enddate: this.state.formData.startdate,
          endhour: this.state.formData.starthour || 0,
          endmin: this.state.formData.startmin || 0
        }, this.state.formData, this);
      }
    } else {
      //end was the one changed
      if (endDate.isValid() && startDate.isValid()) {
        if (endDate.isBefore(startDate)) {
          formsMultiUpdater({
            startdate: this.state.formData.enddate,
            starthour: this.state.formData.endhour || 0,
            startmin: this.state.formData.endmin || 0
          }, this.state.formData, this);
        }
      } else if (endDate.isValid() && !startDate.isValid()) {
        formsMultiUpdater({
          startdate: this.state.enddate.formData,
          starthour: this.state.formData.endhour || 0,
          startmin: this.state.formData.endmin || 0
        }, this.state.formData, this);
      }
    }
  }

  render() {
    if (!this.state.dataLoaded) {
      return <Fragment>Loading...</Fragment>;
    }
    const containerStyle = {
      zIndex: 1999
    };
    const isEditMode = () => isNumber(this.props.edit);

    return (
      <Fragment>
        <Nav tabs>
          <NavItem>
            <NavLink
              className={classnames({active: this.state.activeTab === 'event'})}
              onClick={() => this.toggleTab('event')}>
              Event
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({active: this.state.activeTab === 'additional'})}
              onClick={() => this.toggleTab('additional')}>
              Additional
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({active: this.state.activeTab === 'links'})}
              onClick={() => this.toggleTab('links')}>
              Web Links
            </NavLink>
          </NavItem>
          {isEditMode() && (

            <Fragment>
              <NavItem>
                <NavLink
                  className={classnames({active: this.state.activeTab === 'tasks'})}
                  onClick={() => this.toggleTab('tasks')}>
                  Tasks
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({active: this.state.activeTab === 'notes'})}
                  onClick={() => this.toggleTab('notes')}>
                  Notes
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({active: this.state.activeTab === 'files'})}
                  onClick={() => this.toggleTab('files')}>
                  Files
                </NavLink>
              </NavItem>
              {isNumber(this.props.edit) && this.state.formData['starttime'] < Math.round((new Date()).getTime() / 1000) && (

                <NavItem>
                  <NavLink
                    className={classnames({active: this.state.activeTab === 'aar'})}
                    onClick={() => this.toggleTab('aar')}>
                    AAR
                  </NavLink>
                </NavItem>
              )}
            </Fragment>
          )}
        </Nav>
        <TabContent activeTab={this.state.activeTab}>
          <TabPane tabId="event">
            <Row>
              <Col xs="6" lg="6">
                <FormGroup>
                  <Label for="subject">Title*</Label>
                  <Input
                    type="text"
                    id="subject"
                    value={getFormFieldValue(this.state.formData['subject'])}
                    onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                  />
                </FormGroup>
              </Col>
              <Col xs="6" lg="6">
                <FormGroup>
                  <Label for="eventtype">Event Type</Label>
                  <Input type="select" id="eventtype" placeholder=""
                         value={getFormFieldValue(this.state.formData['eventtype'])}
                         onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                  >
                    <option value={""} disabled>Please Select...</option>
                    {(this.state.eventTypes || []).map((val, i) => {
                      return <option key={i} value={val.id}>{val.display}</option>
                    })}
                  </Input>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col xs="6" lg="6">
                <FormGroup>
                  <Label for="location">Location</Label>
                  <Input
                    type="text"
                    id="location"
                    value={getFormFieldValue(this.state.formData['location'])}
                    onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col xs="6" lg="3">
                <FormGroup>
                  <Label for="startdate">Start Date</Label>
                  <InputGroup>
                    <Input
                      type="date"
                      id="startdate"
                      placeholder="date"
                      value={getFormFieldValue(this.state.formData['startdate'])}
                      onChange={(evt) => formsUpdater(evt, this.state['formData'], this, () => {
                        this.dateValidator('start');
                      })}
                    />
                  </InputGroup>
                  <FormText color="muted">
                    ex. 10/23/2019
                  </FormText>
                </FormGroup>
              </Col>

              <Col xs="6" lg="3">
                <FormGroup>
                  <Label for="starthour">Start Time</Label>
                  <div style={{display: 'flex'}}>
                    <Input type="select" id="starthour" placeholder=""
                           value={getFormFieldValue(this.state.formData['starthour'])}
                           onChange={(evt) => formsUpdater(evt, this.state['formData'], this, () => {
                             this.dateValidator('start');
                           })}
                           disabled={String(getFormFieldValue(this.state.formData['allDay'])) === "true"}
                    >
                      {hourMarks.map((h, i) => <option key={i} value={h}>{zPad(String(h), 2)}</option>)}
                    </Input>
                    <Input type="select" id="startmin" placeholder=""
                           value={getFormFieldValue(this.state.formData['startmin'])}
                           onChange={(evt) => formsUpdater(evt, this.state['formData'], this, () => {
                             this.dateValidator('start');
                           })}
                           disabled={String(getFormFieldValue(this.state.formData['allDay'])) === "true"}
                    >
                      {minMarks.map((m, i) => <option key={i} value={m}>{zPad(String(m), 2)}</option>)}
                    </Input>
                  </div>
                  <FormText color="muted">
                    ex. HH MM (15 45)
                  </FormText>
                </FormGroup>
              </Col>

              <Col xs="6" lg="3">
                <FormGroup>
                  <Label for="enddate">End Date</Label>
                  <InputGroup>
                    <Input
                      type="date"
                      id="enddate"
                      placeholder="date"
                      value={getFormFieldValue(this.state.formData['enddate'])}
                      onChange={(evt) => formsUpdater(evt, this.state['formData'], this, () => {
                        this.dateValidator('end');
                      })}
                    />
                  </InputGroup>
                  <FormText color="muted">
                    ex. 10/23/2019
                  </FormText>
                </FormGroup>
              </Col>
              <Col xs="6" lg="3">
                <FormGroup>
                  <Label for="endhour">End Time</Label>
                  <div style={{display: 'flex'}}>
                    <Input type="select" id="endhour" placeholder=""
                           value={getFormFieldValue(this.state.formData['endhour'])}
                           onChange={(evt) => formsUpdater(evt, this.state['formData'], this, () => {
                             this.dateValidator('end');
                           })}
                           disabled={String(getFormFieldValue(this.state.formData['allDay'])) === "true"}
                    >
                      {hourMarks.map((h, i) => <option key={i} value={h}>{zPad(String(h), 2)}</option>)}
                    </Input>
                    <Input type="select" id="endmin" placeholder=""
                           value={getFormFieldValue(this.state.formData['endmin'])}
                           onChange={(evt) => formsUpdater(evt, this.state['formData'], this, () => {
                             this.dateValidator('end');
                           })}
                           disabled={String(getFormFieldValue(this.state.formData['allDay'])) === "true"}
                    >
                      {minMarks.map((m, i) => <option key={i} value={m}>{zPad(String(m), 2)}</option>)}
                    </Input>
                  </div>
                  <FormText color="muted">
                    ex. HH MM (15 45)
                  </FormText>
                </FormGroup>
              </Col>
              <Col xs="4" lg="2">
                <FormGroup check inline>
                  <Input className="form-check-input"
                         type="checkbox"
                         id="allDay"
                         defaultChecked={getFormFieldValue(this.state.formData['allDay'])}
                         onChange={(evt) => formsCheckboxUpdater(evt, this.state['formData'], this)}
                  />
                  <Label className="form-check-label" check htmlFor="allDay">All Day</Label>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col xs="12">
                <FormGroup>
                  <Label for="email">Details</Label>
                  <Input
                    type="textarea"
                    id="details"
                    cols={15}
                    style={{height: 150}}
                    value={getFormFieldValue(this.state.formData['details'])}
                    onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                  />
                </FormGroup>
              </Col>
            </Row>
          </TabPane>
          <TabPane tabId="additional">
            <Row>
              <Col xs={"12"}>
                <FormGroup>
                  <Label htmlFor="selectedUsers">Users</Label>
                  <Select
                    id="users"
                    name="users"
                    value={this.state.users.filter((user) => user.assigned === 1).map((user) => user.value)}
                    options={this.state.users}
                    onChange={(accessPerms) => {
                      const validUserIds = accessPerms.map((user) => user.value);
                      this.setState({
                        users: this.state.users.map((user) => {
                          return {...user, assigned: validUserIds.indexOf(user.value) === -1 ? 0 : 1}
                        })
                      })
                    }}
                    multi
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col xs="12">
                <FormGroup>
                  <Label for="notes">Notes</Label>
                  <Input
                    type="textarea"
                    id="notes"
                    style={{height: 200}}
                    value={getFormFieldValue(this.state.formData['notes'])}
                    onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                  />
                </FormGroup>
              </Col>
            </Row>
          </TabPane>
          <TabPane tabId={"links"}>
            <Row>
              <Col xs="6" lg="6">
                <FormGroup>
                  <Label for="code">Code</Label>
                  <Input
                    type="text"
                    id="code"
                    value={getFormFieldValue(this.state.formData['code'])}
                    onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                  />
                </FormGroup>
              </Col>
              <Col xs="6" lg="6">
                <FormGroup>
                  <Label for="source">Lead Source</Label>
                  <Input
                    type="text"
                    id="source"
                    value={getFormFieldValue(this.state.formData['source'])}
                    onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col xs="6" lg="6">
                <FormGroup>
                  <Label for="redirectURL">Redirect URL</Label>
                  <Input type="select" id="redirectURL" placeholder=""
                         value={getFormFieldValue(this.state.formData['redirectURL'])}
                         onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                  >
                    <option value={""} disabled>Please Select...</option>
                    {(this.state.eventLinks || []).map((val, i) => {
                      return <option key={i} value={val.url}>{val.url}</option>
                    })}
                  </Input>
                </FormGroup>
              </Col>
              {getFormFieldValue(this.state.formData['code']).length > 0 && (
                <Col xs="6" lg="6">
                  <FormGroup>
                    <Label for="code">URL to Use</Label>
                    <Input
                      type="text"
                      id="code"
                      value={`afbn.us/r/${getFormFieldValue(this.state.formData['code'])}`}
                      readOnly={true}
                    />
                  </FormGroup>
                </Col>
              )}
            </Row>
            <Row>
              <Col xs="12" lg="6">
                <FormGroup check inline>
                  <Input className="form-check-input"
                         type="checkbox"
                         id="soc_media"
                         defaultChecked={getFormFieldValue(this.state.formData['soc_media'])}
                         onChange={(evt) => formsCheckboxUpdater(evt, this.state['formData'], this)}
                  />
                  <Label className="form-check-label" check htmlFor="allDay">Social Media Campaign</Label>
                </FormGroup>
              </Col>
              {!!getFormFieldValue(this.state.formData['soc_media']) && (
                <Fragment>
                  <Col xs="6" lg="3">
                    <FormGroup>
                      <Label for="socstart">Start Date</Label>
                      <InputGroup>
                        <Input
                          type="date"
                          id="socstart"
                          placeholder="date"
                          value={getFormFieldValue(this.state.formData['socstart'])}
                          onChange={(evt) => formsUpdater(evt, this.state['formData'], this, () => {
                            // this.dateValidator('end');
                          })}
                        />
                      </InputGroup>
                      <FormText color="muted">
                        ex. 10/23/2019
                      </FormText>
                    </FormGroup>
                  </Col>
                  <Col xs="6" lg="3">
                    <FormGroup>
                      <Label for="socend">End Date</Label>
                      <InputGroup>
                        <Input
                          type="date"
                          id="socend"
                          placeholder="date"
                          value={getFormFieldValue(this.state.formData['socend'])}
                          onChange={(evt) => formsUpdater(evt, this.state['formData'], this, () => {
                            // this.dateValidator('end');
                          })}
                        />
                      </InputGroup>
                      <FormText color="muted">
                        ex. 10/23/2019
                      </FormText>
                    </FormGroup>
                  </Col>
                </Fragment>
              )}

            </Row>
          </TabPane>
          <TabPane tabId={"notes"}>
            <NotesTab noteType={"events"}
                      notes={this.state.notes}
                      lmsId={this.props.edit}
                      onUpdate={(notes) => this.setState({notes})}
            />
          </TabPane>
          <TabPane tabId={"files"}>
            <FilesTab fileType={"events"}
                      documents={this.state.files}
                      lmsId={this.props.edit}
                      canSave={true}
                      canDelete={hasPermission(RequiredPermissions.EventRemove)}
                      eventKey={"eid"}
                      onUpdate={(files) => this.setState({files})}
            />
          </TabPane>
          <TabPane tabId={"tasks"}>
            <TasksTab fileType={"events"}
                      tasks={this.state.tasks}
                      users={this.state.users.filter((user) => user.assigned === 1)}
                      eventId={this.props.edit}
                      canSave={false}
                      start={this.state.formData.starttime}
                      onUpdate={(tasks) => this.setState({tasks})}
            />
          </TabPane>
        </TabContent>
      </Fragment>
    )
  }

  // showAttachLMSPicker() {
  //   this.setState({showLMSPicker: true});
  // }

  // attachLMSEntry(lead) {
  //   const obj = {
  //     attachedLeads: lead,
  //     details: this.genUserDetails(lead),
  //     subject: this.genSubject(lead)
  //   }
  //   formsMultiUpdater(obj, this.state['formData'], this, () => {
  //     this.setState({showLMSPicker: false})
  //   });
  // }

  // genUserDetails(lead) {
  //   let details = getFormFieldValue(this.state.formData['details']);
  //   if (details.length > 0) details += "\r\n";
  //   details = details + (lead.maritalstatus === "Married" ? "Married " + (lead.spfname != "" ? "- Spouse Name: " + lead.spfname + " " + lead.splname : " - Spouse Unknown") + "\r\n" : "") + "Address:\r\n" + lead.address1 + (lead.address2 != "" ? ", " + lead.address2 + "\r\n" : "\r\n");
  //   details = details + "" + lead.city + ", " + lead.state + " " + lead.zip;
  //   if (lead.cellphone !== "") {
  //     details = details + "\r\nCell #: " + lead.cellphone;
  //   }
  //   if (lead.homephone !== "") {
  //     details = details + "\r\nHome #: " + lead.homephone;
  //   }
  //   if (lead.dutyphone !== "") {
  //     details = details + "\r\nDuty #: " + lead.dutyphone;
  //   }
  //   if (lead.homeemail !== "") {
  //     details = details + "\r\nHome Email: " + lead.homeemail;
  //   }
  //   if (lead.dutyemail !== "") {
  //     details = details + "\r\nDuty Email: " + lead.dutyemail;
  //   }
  //   return details;
  // }

  // genSubject(lead) {
  //   let subject = getFormFieldValue(this.state.formData['subject']);
  //   if (subject.length === 0) {
  //     return (lead.rank + " " + lead.fname + " " + lead.lname).replace("  ", " ");
  //   } else {
  //     return subject;
  //   }
  // }
}


// WEBPACK FOOTER //
// ./src/containers/Events/EventEntryEditor.js